define([
	"dojo/_base/declare",
	"csi/toolbar/MultiSelectSwitchboard"
], function(declare,MultiSelectSwitchboard) {

	return declare(MultiSelectSwitchboard, {
		bDelayInitialization: true,
		disableButtonAction: true,
		idViewProperty: "columnNodeUrls",
		switchboardPath: "Child:Review/Child:ReviewSizes",

		canShowPlugin: function() {
			// summary: return true if more than one size
			return this.store && this.store.isLoaded() && (this.store.query().length > 1);
		},

		validatePlugin: function(/*Context*/ctx) {
			// summary: hide if printing
			return !ctx.bPrint;
		}
	});
});